import "./Multipal-typing.css";

const STACK = ["React.js", "Python", "Flutter", "iOS / Swift", "React Native", "Android / Kotlin"];

const SERVICES = [
  {
    icon: "fa-solid fa-code",
    title: "Web Applications",
    text: "Custom web platforms built with React, Next.js and Node — fast, secure, and scalable.",
    stack: ["React", "Next.js", "TypeScript"],
  },
  {
    icon: "fa-solid fa-mobile-screen-button",
    title: "Mobile Apps",
    text: "Cross-platform and native apps for iOS and Android that feel tailor-made on every device.",
    stack: ["Flutter", "React Native", "Swift", "Kotlin"],
  },
  {
    icon: "fa-solid fa-server",
    title: "Backend & APIs",
    text: "Battle-tested APIs, microservices and data pipelines powered by Python and Node.",
    stack: ["Python", "FastAPI", "Node.js"],
  },
  {
    icon: "fa-solid fa-cloud",
    title: "Cloud & DevOps",
    text: "AWS, GCP and Azure deployments with CI/CD, containers and monitoring built in.",
    stack: ["AWS", "Docker", "Kubernetes"],
  },
  {
    icon: "fa-solid fa-users-gear",
    title: "IT Staffing",
    text: "Hand-picked engineers and specialists matched to your roles with skill-based vetting.",
    stack: ["Contract", "Full-time", "Remote"],
  },
  {
    icon: "fa-solid fa-lightbulb",
    title: "IT Consulting",
    text: "From need-analysis to solution design — we guide your digital journey end-to-end.",
    stack: ["Strategy", "Architecture", "Audit"],
  },
];

const Multipaltyping = () => {
  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="services__head reveal">
          <span className="eyebrow">What we build</span>
          <h2 className="section-title">
            We develop in{" "}
            <span className="typing">
              <ul className="typing__list">
                {STACK.map((s) => (
                  <li key={s}>
                    <span className="grad">{s}</span>
                  </li>
                ))}
              </ul>
            </span>
          </h2>
          <p className="section-sub">
            A full-stack product team covering web, mobile, cloud and AI — so you can ship more
            while we handle the hard parts.
          </p>
        </div>

        <div className="services__grid">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              className="service reveal"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="service__icon">
                <i className={s.icon} />
              </div>
              <h3 className="service__title">{s.title}</h3>
              <p className="service__text">{s.text}</p>
              <ul className="service__stack">
                {s.stack.map((t) => (
                  <li key={t}>{t}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Multipaltyping;
